import JsPDF from "jspdf";
import { applyPlugin } from "jspdf-autotable";
applyPlugin(JsPDF);
import moment from "moment";

function getRectablesPositions(lastAutoTable, modules) {
  const { body, styles } = lastAutoTable;
  const { lineWidth } = styles.styles;
  const rectablesPositions = [];
  let rowIndex = 1;
  let currentHight = body[0].height;
  for (const module of modules) {
    const startY = currentHight;
    let moduleIndex = rowIndex;
    for (const _ of module.subjects) {
      moduleIndex += 1;
      currentHight += body[moduleIndex].height - lineWidth;
    }
    rowIndex = moduleIndex + 1;
    const moduleEndY = currentHight;
    currentHight += body[moduleIndex].height;
    if (module.subjects.length > 2) {
      rectablesPositions.push({
        moduleStartY: startY,
        moduleEndY: moduleEndY,
        moduleName: module.namePersonalized,
      });
    }
  }

  return rectablesPositions;
}

const SchoolHeader = {
  name: "ETABLISSEMENT MAHJOUB",
  logo: "/resources/images/templatesBulletin/logo_mahjoub.png",
  address: "32.rue de Niger-12, rue El Hamdia - 1002 Tunis",
  phones: ["71 891 798", "29 306 742"],
  email: "contact@ecolemahjoub.com",
};

class bulletinMJ {
  constructor(
    students,
    classInfo,
    appreciations = null,
    conduites = null,
    attendance = null
  ) {
    this.doc = new JsPDF();
    this.ctx = this.doc.context2d;
    this.pdf_width = this.doc.internal.pageSize.width;
    this.pdf_height = this.doc.internal.pageSize.height;
    this.X = 0;
    this.Y = 0;
    this.currentStudent = 0;
    this.appreciations = appreciations || [
      "Félicitations",
      "Tableau d'honneur",
      "Billet de satistfaction",
      "Bon point",
      "Manque de travail",
    ];
    this.conduites = conduites || ["Bonne", "Assez bonne", "A améliorer"];
    this.attendance = attendance;
    this.students = students;
    this.classInfo = classInfo;
    this.schoolHeader = SchoolHeader;
    this.incrementCurrentAttendance();
  }
  incrementCurrentStudent() {
    this.currentStudent += 1;
  }
  incrementCurrentAttendance() {
    this.currentAttendance =
      this.attendance && this.students.length > 0
        ? this.attendance[this.students[this.currentStudent].id]
        : {
            latence: 0,
            absence: 0,
          };
  }
  /*
    Draw the header of the bulletin
    @param {bulletinMJ} bulletin
*/
  async drawBulletinHeader() {
    const { name, logo, address, phones, email } = this.schoolHeader;
    const classInfo = this.classInfo;
    const studentInfo = this.students[this.currentStudent];
    const pdfWidth = this.pdf_width;
    const doc = this.doc;
    let logoImage = null;
    try {
      logoImage = await new Promise((resolve, reject) => {
        const img = new Image();
        img.src = logo;
        img.onload = () => resolve(img); // Resolve the promise when the image loads
        img.onerror = (err) => reject(err); // Reject if there's an error
      });
    } catch (err) {
      console.log("Error loading logo: ", err);
    }
    // info section
    doc.setFont("Times", "bold");
    doc.setFontSize(14);
    doc.text(name, 20, 20);
    doc.setFont("Times", "normal");
    doc.setFontSize(10);
    doc.text(address, 20, 27);
    const phoneText = "Tel: " + phones.join(" - ");
    const emailText = "Email: " + email;
    const addressWidth = doc.getTextWidth(address);
    const phoneWidth = doc.getTextWidth(phoneText);
    const emailWidth = doc.getTextWidth(emailText);
    doc.text(phoneText, 20 + addressWidth / 2 - phoneWidth / 2, 32);
    doc.text(emailText, 20 + addressWidth / 2 - emailWidth / 2, 37);

    // logo section
    if (logoImage) doc.addImage(logoImage, "PNG", pdfWidth - 50, 2, 50, 50);

    // Bulletin header
    doc.setFont("Times", "bold");
    doc.setFontSize(18);
    const headerWidth = doc.getTextWidth("BULLETIN DE NOTES");
    doc.text("BULLETIN DE NOTES", pdfWidth / 2 - headerWidth / 2, 50);

    doc.setFontSize(12);
    const schoolarYear = "Année scolaire :" + classInfo.schoolarYear;
    const trimestre = classInfo.trimester;
    const yearWidth = doc.getTextWidth(schoolarYear);
    doc.text(schoolarYear, pdfWidth / 2 - yearWidth / 2, 58);
    const trimestreWidth = doc.getTextWidth(trimestre);
    doc.text(trimestre, pdfWidth / 2 - trimestreWidth / 2, 64);

    // Student Info
    doc.setFontSize(12);
    doc.text("Classe:                     " + classInfo.className, 10, 72);
    doc.text(
      "Nom et Prénom:    " + (studentInfo.fullNameFr || ""),
      10,
      77
    );
    doc.text(
      "Date de naissance:  " +
        moment(studentInfo.birthDate).format("DD/MM/YYYY"),
      10,
      83
    );
  }
  async drawBulletinBody() {
    const doc = this.doc;
    const headers = [
      { name: "Matière", key: "subject" },
      { name: "Coef", key: "coef" },
      { name: "Moy.", key: "moy" },
      { name: "Max", key: "max" },
      { name: "Min", key: "min" },
      { name: "Moy c", key: "moyc" },
      { name: "Appréciation des enseignants", key: "appreciation" },
    ];
    const modules = this.students[this.currentStudent].modules;
    const rows = [
      headers.map((header) => ({
        content: header.name,
        styles: {
          fillColor: [220, 220, 220],
          fontStyle: "bold",
          fontSize: 7,
          halign: "center",
          valign: "middle",
        },
      })),
    ];
    const subjectsHeaders = [
      { name: "Matière", key: "namePersonalized" },
      { name: "Coef", key: "coef" },
      { name: "Moy", key: "mark" },
      { name: "Max", key: "max" },
      { name: "Min", key: "min" },
      { name: "Moy c", key: "average" },
      { name: "Appréciation des enseignants", key: "appreciation" },
    ];
    for (const module of modules) {
      const firstRowInModule = true;
      for (const subject of module.subjects) {
        rows.push(
          subjectsHeaders.map((header) => ({
            content:
              firstRowInModule && header.key == "appreciation"
                ? (module.appreciation || "")
                : subject[header.key]
                ? subject[header.key]
                : "--",
            rowSpan:
              firstRowInModule && header.key == "appreciation"
                ? module.subjects.length + 1
                : 1,
            styles: {
              halign: header.key != "namePersonalized" ? "center" : "left",
              valign: "middle",
              fontStyle: header.key == "moy" ? "bold" : "normal",
              fontSize: 7,
            },
          }))
        );
        firstRowInModule = false;
      }
      rows.push([
        {
          content: "Moyenne " + module.namePersonalized,
          styles: {
            fontStyle: "bold",
            fontSize: 8,
          },
        },
        {
          content: module.moyenne,
          colSpan: 5,
          styles: {
            fontStyle: "bold",
            halign: "center",
            valign: "middle",
            fontSize: 8,
          },
        },
        [],
      ]);
    }
    this.Y = doc.lastAutoTable.y;
    const TableStartY = 90;
    const TableStartX = 15;
    const TableLineWidth = 0.1;
    doc.autoTable({
      body: rows,
      startY: TableStartY,
      margin: { left: TableStartX },
      styles: {
        font: "helvetica",
        fontSize: 9,
        cellPadding: 2,
      },
      headStyles: {
        fillColor: [220, 220, 220],
        textColor: 0,
        fontStyle: "bold",
      },
      columnStyles: {
        0: { cellPadding: 1, cellWidth: 50 },
        1: { cellPadding: 1, cellWidth: 15 },
        2: { cellPadding: 1, cellWidth: 15 },
        3: { cellPadding: 1, cellWidth: 15 },
        4: { cellPadding: 1, cellWidth: 15 },
        5: { cellPadding: 1, cellWidth: 15 },
        6: { cellPadding: 1, cellWidth: 60 },
      },
      styles: {
        fontSize: 7,
        lineColor: 0,
        lineWidth: TableLineWidth,
      },
      theme: "grid",
    });

    const rectablesPositions = getRectablesPositions(
      doc.lastAutoTable,
      modules
    );
    const rectableStartX = TableStartX - 5;
    doc.setLineWidth(0.1);
    doc.setDrawColor(0, 0, 0);
    doc.setFontSize(11);
    doc.setFont("PT Bold Heading");
    for (const rectable of rectablesPositions) {
      let { moduleStartY, moduleEndY, moduleName } = rectable;
      moduleStartY += TableStartY;
      moduleEndY += TableStartY;
      doc.rect(rectableStartX, moduleStartY, 5, moduleEndY - moduleStartY);
      doc.text(moduleName, rectableStartX + 3.5, moduleEndY - 1, {
        angle: 90,
      });
    }
  }
  async drawBulletinFooter() {
    let y = this.Y;
    let x = this.X;
    const doc = this.doc;
    const headers = ["Moyenne", "Français", "Arabe", "Générale"];
    const rows = [
      headers.map((header) => ({
        content: header,
        styles: {
          fillColor: [220, 220, 220],
          fontStyle: "bold",
          fontSize: 7,
          halign: "center",
          valign: "middle",
        },
      })),
      [
        {
          content: this.classInfo.trimester + " /20",
          styles: {
            fontStyle: "bold",
            fontSize: 8,
          },
        },
        {
          content: this.students[this.currentStudent].moyFr,
          styles: {
            fontStyle: "normal",
            halign: "center",
            valign: "middle",
            fontSize: 8,
          },
        },
        {
          content: this.students[this.currentStudent].moyAr,
          styles: {
            fontStyle: "normal",
            halign: "center",
            valign: "middle",
            fontSize: 8,
          },
        },

        {
          content: this.students[this.currentStudent].moyenne,
          styles: {
            fontStyle: "normal",
            halign: "center",
            valign: "middle",
            fontSize: 8,
          },
        },
      ],
    ];
    doc.autoTable({
      body: rows,
      margin: { left: 10 },
      styles: {
        font: "helvetica",
        fontSize: 9,
        cellPadding: 2,
      },
      headStyles: {
        fillColor: [220, 220, 220],
        textColor: 0,
        fontStyle: "bold",
      },
      columnStyles: {
        0: { cellPadding: 1, cellWidth: 30 },
        1: { cellPadding: 1, cellWidth: 15 },
        2: { cellPadding: 1, cellWidth: 15 },
        3: { cellPadding: 1, cellWidth: 15 },
      },
      styles: {
        fontSize: 7,
        lineColor: 0,
        lineWidth: 0.1,
      },
      theme: "grid",
    });
    y = doc.lastAutoTable.finalY;
    x = 90;
    const conduitStartY = y;
    const conduitStartX = x;
    doc.setFontSize(12);
    doc.text("Conduite", x, y);
    let ystep = 5;
    doc.setFontSize(12);
    doc.setFont("Times", "normal");
    doc.setDrawColor(0, 0, 0);
    doc.setLineWidth(0.3);
    y += ystep;

    for (const conduite of this.conduites) {
      doc.rect(x, y, 3, 3);
      doc.text(conduite, x + 4, y + 3);
      y += ystep;
    }
    doc.setFontSize(12);
    doc.setFont("Times", "bold");
    const disciplineStartX =
      conduitStartX +
      Math.max(...this.conduites.map((c) => doc.getTextWidth(c))) +
      15;
    const disciplineStartY = conduitStartY;
    doc.text("Discipline & assiduité", disciplineStartX, disciplineStartY);
    x = disciplineStartX + 3;
    y = conduitStartY + ystep;
    doc.setFontSize(10);
    doc.setFont("Times", "normal");
    doc.text("Retard: " + this.currentAttendance.latence, x, y);
    y += ystep;
    doc.text("Absence: " + this.currentAttendance.absence, x, y);

    y = doc.lastAutoTable.finalY + 10;
    x = 5;

    doc.setFontSize(11);
    doc.setFont("Times", "bold");
    const appreciationTitleY = y;
    doc.text(
      "Appréciations du conseil de classe".toUpperCase(),
      x,
      appreciationTitleY
    );
    y += ystep;
    x = 10;
    doc.setFontSize(10);
    doc.setFont("Times", "normal");
    doc.text("Fr", x, y);
    doc.text("Ar", x + doc.getTextWidth("Fr") + 2, y);
    ystep = 4;
    y += ystep;
    x -= 1;
    for (const appreciation of this.appreciations) {
      doc.rect(x, y, 3, 3);
      doc.rect(x + 4, y, 3, 3);
      doc.text(appreciation, x + 9, y + 3);
      y += ystep;
    }
    doc.setFontSize(14);
    doc.setFont("Times", "bold");
    doc.text(
      "La directrice",
      this.pdf_width - doc.getTextWidth("La directrice") - 40,
      this.pdf_height - 40
    );
    doc.setFontSize(10);
    doc.setFont("Times", "bold");
    doc.text(
      "Bulletin à conserver précieusement. Aucun duplicata ne sera délivré.",
      50,
      this.pdf_height - 5
    );

    x -= 1;
    y = this.pdf_height - 10 - ystep;
    doc.setLineDashPattern([0.5, 1], 0);
    doc.line(
      x,
      y,
      this.pdf_width - doc.getTextWidth("La directrice") / 2 - 40,
      y
    );
    y -= ystep;
    doc.line(
      x,
      y,
      this.pdf_width - doc.getTextWidth("La directrice") / 2 - 40,
      y
    );
  }
}

async function drawBulletin(
  students,
  classInfo,
  appreciations = null,
  conduites = null
) {
  const bulletin = new bulletinMJ(
    students,
    classInfo,
    appreciations,
    conduites
  );
  await bulletin.drawBulletinHeader();
  await bulletin.drawBulletinBody();
  await bulletin.drawBulletinFooter();
  const btName = `bulletin-${classInfo.className}-${students[0].fullNameFr}-${classInfo.trimester}`;
  bulletin.doc.save(`bulletin-${btName}.pdf`);
  return bulletin.doc.output("bloburl");
}

async function drawAllBulletins(
  students,
  classInfo,
  appreciations = null,
  conduites = null
) {
  const bulletin = new bulletinMJ(
    students,
    classInfo,
    appreciations,
    conduites
  );
  for (const _ of students) {
    await bulletin.drawBulletinHeader();
    await bulletin.drawBulletinBody();
    await bulletin.drawBulletinFooter();
    bulletin.incrementCurrentStudent();
    bulletin.incrementCurrentAttendance();
    bulletin.doc.addPage();
    bulletin.X = 0;
    bulletin.Y = 0;
  }
  const btName = `bulletin-${classInfo.className}-${classInfo.trimester}`;
  bulletin.doc.save(`bulletin-${btName}.pdf`);
  return bulletin.doc.output("bloburl");
}
export default { drawBulletin, drawAllBulletins };
